import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const ErrorLoadBillingIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="251"
        height="253"
        viewBox="0 0 251 253"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <rect x="0.5" y="3" width="250" height="250" fill="#F9F9F9" />
        <path
          d="M194.565 49.2876C211.865 73.36 221.22 97.3592 221.942 120.107C222.752 142.857 214.95 164.427 204.648 186.66C194.343 208.82 181.462 231.64 164.168 234.658C146.873 237.603 125.161 220.818 101.465 211.323C77.683 201.898 51.934 199.836 35.8789 185.63C19.8442 171.348 13.5882 144.919 16.8273 119.151C20.1395 93.3852 33.0929 68.2689 52.963 44.7229C72.9091 21.0921 99.9181 -0.994715 125.971 0.0346181C152.097 1.06688 177.34 25.2123 194.565 49.2876Z"
          fill="white"
        />
        <path
          d="M57.5435 44.5078L57.5435 134.891L191.444 134.891L191.444 44.5078L57.5435 44.5078Z"
          fill="#AAAAAA"
        />
        <path
          d="M190.787 136.23H56.8858L47.501 154.976H200.148L190.787 136.23Z"
          fill="#AAAAAA"
        />
        <rect
          x="47.5107"
          y="154.976"
          width="152.647"
          height="4.01702"
          fill="#D9D9D9"
        />
        <path
          d="M62.8999 49.8639L62.8999 129.535L186.089 129.535L186.089 49.8639L62.8999 49.8639Z"
          fill="#F2F7FF"
        />
        <path
          d="M124.51 110.789C136.342 110.789 145.934 101.197 145.934 89.3646C145.934 77.5323 136.342 67.9404 124.51 67.9404C112.677 67.9404 103.085 77.5323 103.085 89.3646C103.085 101.197 112.677 110.789 124.51 110.789Z"
          fill="#EE595A"
        />
        <path
          d="M132.917 79.9915L115.137 98.0681M116.102 79.9915L133.883 98.0681"
          stroke="#F2F7FF"
          strokeWidth="5"
          strokeMiterlimit="10"
        />
        <path
          d="M156.446 135.41C152.337 135.08 143.436 138.774 144.438 145.327C145.124 149.836 153.51 156.634 157.066 159.571C160.459 165.457 178.219 191.21 192.059 210.816L222.514 197.344C204.785 178.298 184.059 160.316 175.441 153.159C171.871 147.032 164.644 136.064 156.446 135.41Z"
          fill="#FFB688"
        />
        <path
          d="M93.8295 133.688C97.8742 132.893 107.136 135.554 106.884 142.179C106.714 146.736 99.1535 154.442 95.9533 157.763C93.25 163.996 78.5258 191.597 66.9982 212.646L35.2115 202.716C50.6662 181.782 69.219 161.565 76.9703 153.477C79.8216 146.984 85.7582 135.267 93.8295 133.688Z"
          fill="#FFB688"
        />
      </svg>
    );
  }
);
export default ErrorLoadBillingIcon;
